export default "__VITE_ASSET__1263a6a2__"